const Contacts = () => {
  return (
    <main className="section">
      <div className="container">
        <h1 className="title-1">Contacts</h1>

        <ul className="content-list">
          <li className="content-list__item">
            <h2 className="title-2">Location</h2>
            <p className='accent'>Salo, Finland</p>
          </li>
          <li className="content-list__item">
            <h2 className="title-2">Telegram / WhatsApp</h2>
            <p>
              <a href="tel:+358468130887">+358 4681 308 87</a>
            </p>
          </li>
          <li className="content-list__item">
            <h2 className="title-2">Email</h2>
            <p>
              <a href="mailto:info@pixelcraft.fi">info@pixelcraft.fi</a>
            </p>
          </li>
        </ul>
      </div>
    </main>
  );
};

export default Contacts;
